import type {} from '@redux-devtools/extension';
import { devtools } from 'zustand/middleware';

export const devtoolsInDevelopment: typeof devtools = (initializer, options) =>
  devtools(initializer, {
    ...options,
    enabled: ['LOCAL', 'DEV', 'QA'].includes(process.env.ENV ?? '') ? options?.enabled : false,
  });
